import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIStudi {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }


    async initInsert(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);

        return axios.post(this.getUrlDomain("TwoRecruitStudiInitInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async insertStudio(studio, user) {

        let formData = new FormData();

        formData.append("username", user);

        for (var key in studio) {
            formData.append(key, studio[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitStudiInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initEdit(id, user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitStudiInitEditApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }


    async updateStudio(studio, user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);

        for (var key in studio) {
            formData.append(key, studio[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitStudiUpdApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async deleteStudio(user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);


        return axios.post(this.getUrlDomain("TwoRecruitStudiDelApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initFilter(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitStudiInitFilterApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

}

export default new APIStudi({
    url: "https://services.ebadge.it/public/api/"
})
